<template>
  <div class="timeline-wrapper">
    <div class="timeline">
      <div class="emptyWrapper" v-if="progressList.length === 0">
        <Empty :emptyImg="emptyImg" emptyText="暂无搜索结果" />
      </div>
      <template v-else>
        <div
          class="timelineList"
          v-infinite-scroll="loadMore"
          :infinite-scroll-disabled="!hasMore"
          :infinite-scroll-delay="200"
          :infinite-scroll-distance="50"
        >
          <div
            v-for="(item, index) in progressList"
            :key="item.businessId"
            :class="['timelineItem', item.status === 1 ? 'completed' : 'inProgress']"
          >
            <div class="description">
              <!-- 时间轴 -->
              <div class="graphic">
                <div
                  class="dot"
                  :style="index === 0 ? { marginTop: '5px' } : { marginTop: 0 }"
                ></div>
                <div v-if="index + 1 !== progressList.length" class="line"></div>
              </div>
              <!-- 内容 -->
              <div class="content">
                <div class="title">
                  <div>{{ item.businessTypeName }}</div>
                  <!-- 结果link -->
                  <div
                    v-if="[3, 4].includes(item.businessType) && item.status === 1"
                    class="link"
                    @click="handleClick(item)"
                  >
                    {{ progressBtnType[item.businessType] }}
                    <RightOutlined class="right-icon" />
                  </div>
                </div>
                <div class="time">{{ item.executeTime }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- <FollowUpResults ref="followUpResultsRef" :businessId="resultInfo.businessId" /> -->
    </div>
    <!-- 问卷结果iframe -->
    <Info ref="infoRef" :url="resultsUrl" :title="resultTitle"></Info>
  </div>
</template>

<script setup>
import { defineProps, ref, reactive, onMounted } from 'vue'
import emptyImg from '@/assets/img/empty.png'
import Empty from '../../../../../components/Empty'
import { getQuestionResult, getServiceProgress } from '@/api/workPlace/serviceAttribution'
import { progressBtnType } from '../../constant'
import { RightOutlined } from '@ant-design/icons-vue'
import Info from '@/views/WorkPlace/Container/chat/components/ScaleResults/Info.vue'
import { getToken } from '@/utils/auth'

const infoRef = ref(null)
// 分页当前页
const curPage = ref(1)
// 分页大小
const pageSize = ref(20)
// 是否还有更多内容
const hasMore = ref(false)
// 加载状态
const loading = ref(false)
// 服务列表
const progressList = ref([])
// 问卷结果数据
const resultInfo = reactive({})
const resultsUrl = ref('')
const resultTitle = ref('')
const props = defineProps({
  handleQuestionnaire: {
    type: Function
  },
  parentInstanceSn: {
    type: String,
    default: ''
  },
  handleOpenAppPage: {
    type: Function
  },
  userId: {
    type: String,
    default: ''
  }
})
// 获取服务进度列表
const getProgressList = async () => {
  try {
    if (loading.value === true) return
    loading.value = true
    const { parentInstanceSn } = props
    const params = {
      curPage: curPage.value,
      pageSize: pageSize.value,
      parentInstanceSn
    }
    const result = await getServiceProgress(params)
    const { dataList } = result || []
    if (curPage.value === 1) {
      progressList.value = [...dataList]
    } else {
      progressList.value = [...progressList.value, ...dataList]
    }
    hasMore.value = dataList.length >= pageSize.value
    curPage.value = curPage.value + 1
  } catch {
    hasMore.value = false
  } finally {
    loading.value = false
  }
}
// 上滑加载数据
const loadMore = async () => {
  await getProgressList()
}
// 查看问卷/随访结果
const handleClick = async item => {
  const { businessId, businessType, subBusinessType, oldQuestionnaireUrl, oldQuestionnaireName } =
    item
  Object.assign(resultInfo, item)
  const authParams = `&token=${getToken()}&userId=${props.userId}&hideNavbar=true`
  if (businessType === 3) {
    resultsUrl.value = `${process.env.VUE_APP_SCALE_RESULTS}followupResults?businessId=${businessId}${authParams}`
    resultTitle.value = '随访结果'
  } else {
    if (subBusinessType === 2) {
      resultsUrl.value = oldQuestionnaireUrl
      resultTitle.value = oldQuestionnaireName
    } else {
      try {
        const { formName } = await getQuestionResult({
          businessId,
          subBusinessType
        })
        resultsUrl.value = `${process.env.VUE_APP_SCALE_RESULTS}questionnaireResults?businessId=${businessId}&subBusinessType=${subBusinessType}${authParams}`
        resultTitle.value = formName
      } catch (error) {
        console.error('异常:', error)
      }
    }
  }
  infoRef.value.showDrawer()
}
// 初始化
const init = async () => {
  // 获取服务进度列表
  await getProgressList()
}
onMounted(() => {
  // 初始化
  init()
})
</script>

<style scoped lang="scss">
.timeline-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  .timeline {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;

    .emptyWrapper {
      height: 280px;
    }

    .timelineList {
      flex: 1;
      // overflow: scroll;
      min-height: 0;
      padding-left: 60px;
      .timelineItem {
        display: flex;

        .description {
          display: flex;

          .graphic {
            display: flex;
            flex-direction: column;

            .line {
              flex: 1;
              margin-left: 48%;
            }
          }

          .content {
            .title {
              display: flex;
              align-items: flex-end;
              font-size: 16px;
              margin-bottom: 10px;
              line-height: 16px;
              .link {
                cursor: pointer;
                margin-left: 12px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #1890ff;
                font-size: 12px;
                font-weight: 400;
                .right-icon {
                  margin-left: 6px;
                }
              }
            }
            .time {
              font-weight: 400;
              font-size: 13px;
              margin-bottom: 24px;
              color: #999999;
            }
          }
        }
      }
    }

    .completed {
      .graphic {
        margin-right: 17px;
        .dot {
          width: 18px;
          height: 18px;
          background-image: url('~@/assets/img/successProgress.png');
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }
        .line {
          border-left: 1px solid #16c09b;
        }
      }

      .content {
        .title {
          font-weight: 500;
          color: #333333;
        }
      }
    }

    .inProgress {
      .graphic {
        margin-left: 3px;
        margin-right: 21.5px;
        .dot {
          width: 9px;
          height: 9px;
          border-radius: 50%;
          margin-left: 1px;
          background-color: #bababa;
        }
        .line {
          border-left: 1px dashed #d4d4d4;
        }
      }

      .content {
        .title {
          font-weight: 400;
          color: #666666;
        }
      }
    }
  }
}
</style>
